import { useNavigate } from "react-router-dom";
import EmConstrucao from "../EmConstrucao";


function VeiculoDetalhe() {
    const navigate = useNavigate();
    const handleOnClickVotlar = () => {
        navigate("/portal/veiculos");
    }
    return (
        <div>
            <button onClick={() => handleOnClickVotlar()}>Voltar</button>
            <EmConstrucao />
        </div>
    )
}

export default VeiculoDetalhe
